export default (elem, args) => {
  if (args.publicationLinks) {
    const title = elem.querySelector('.card-grid__card-title');
    const body = elem.querySelector('.card-grid__card-body');
    const showButton = elem.querySelector('.card-grid__card-button');
    const publications = elem.querySelector('.card-grid__card-publications');
    const backButton = elem.querySelector('.card-grid__card-publications-back-button');

    window.addEventListener("load", () => {
      elem.style.minHeight = `${elem.clientHeight}px`;
    });

    showButton.addEventListener('click', () => {
      title.style.display = 'none'
      body.style.display = 'none'
      showButton.style.display = 'none'
      publications.style.display = 'block'
    });

    backButton.addEventListener('click', () => {
      console.log('clicked')
      title.style.display = 'block'
      body.style.display = 'block'
      showButton.style.display = 'block'
      publications.style.display = 'none'
    });
  }
}